import { fetchConToken } from "../helpers/fetch";
import { armarParametrosComunicacionEmpresas } from "../helpers/parametros";

const ComunicacionConEmpresasService = {
    TraerEstadosComunicacion: () => {
        return fetchConToken(`SuspensionCobertura/TraerEstadosComunicacion`);
    },
    TraerDatosSuspensionEmpresa: (cuit) => {
        return fetchConToken(`SuspensionCobertura/TraerDatosSuspensionEmpresa/${cuit}`);
    },
    TraerDatosSuspensionAfiliados: (cuit) => {
        return fetchConToken(`SuspensionCobertura/TraerDatosSuspensionAfiliados/${cuit}`);
    },
    SuspenderCobertura: (cuit, estado) => {
        return fetchConToken(`SuspensionCobertura/SuspenderCobertura/${cuit}/${estado}`, {}, "POST")
    },
    NuevaSolicitudComunicacion: (data) => {
        return fetchConToken(`SuspensionCobertura/NuevaSolicitudComunicacion`, data, "POST")
    },
    TraerSolicitudesComunicacion: (idEstado, cuit, idAreaUsuario,fechaCargaDesde, fechaCargaHasta, fechaUltimaModificacionDesde, fechaUltimaModificacionHasta) => {
        return fetchConToken(`SuspensionCobertura/TraerSolicitudesDeComunicacion?${armarParametrosComunicacionEmpresas(
            idEstado, cuit, idAreaUsuario, fechaCargaDesde, fechaCargaHasta, fechaUltimaModificacionDesde, fechaUltimaModificacionHasta)}`);
    },
    NuevoMensajeComunicacion: (data) => {
        return fetchConToken(`SuspensionCobertura/NuevoMensajeComunicacion`, data, "POST")
    },
    TraerMensajesComunicacion: (idBandejaSuspension) => {
        return fetchConToken(`SuspensionCobertura/TraerMensajesComunicacion/${idBandejaSuspension}`);
    },
    CerrarCasoComunicacion: (cuit, mensaje) => {
        return fetchConToken(`SuspensionCobertura/CerrarCaso/${cuit}`, { mensaje }, "POST");

    },
    TraerObservacionesEmpresa: (cuit) => {
        return fetchConToken(`SuspensionCobertura/TraerObservacionesEmpresa/${cuit}`);
    },
    NuevaObservacionEmpresa: (data) => {
        return fetchConToken(`SuspensionCobertura/EnviarObservacionEmpresa`, data, "POST");
    },
    TraeDocumentacionPorCuit: (cuit) => {
        return fetchConToken(`Documentacion_ComunicacionConEmpresas/${cuit}`)
    },
    EliminarDocumentacion: (idDocumentacion) => {
        return fetchConToken(`Documentacion_ComunicacionConEmpresas/${idDocumentacion}`, {}, "DELETE")
    },
    GenerarExcel:(idBandeja) => {
        return fetchConToken(`SuspensionCobertura/GenerarExcelInfoCaso/${idBandeja}`)
    },
    MarcarLeidoCasoSuspension:(idBandeja,idAreaUsuario)=>{
        return fetchConToken(`SuspensionCobertura/MarcarLeidoCaso/${idBandeja}/${idAreaUsuario}`,{},"PUT")

    },
   CambiarEstadoSemaforo:(data)=>{
        return fetchConToken(`SuspensionCobertura/CambiarEstadoSemaforoSolicitud/`,data,"PUT")

    }
}

export { ComunicacionConEmpresasService as default }; 